import React from 'react'
import { useTranslation } from 'react-i18next'

import Chip from '@mui/material/Chip'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'

import { CuppingDescriptor } from '../../types/cuppingFormConfig'

interface DescriptorsProps {
  selectedDescriptors: Array<CuppingDescriptor>
  suggestedDescriptors: Array<CuppingDescriptor>
  onChange: (newDescriptors: Array<CuppingDescriptor>) => void
}

const Descriptors = (props: DescriptorsProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Autocomplete
      sx={{ width: '100%' }}
      multiple
      //disableCloseOnSelect
      options={props.suggestedDescriptors}
      getOptionLabel={(option: CuppingDescriptor) => option.name}
      isOptionEqualToValue={(option: CuppingDescriptor, value: CuppingDescriptor) => option.id === value.id}
      onChange={(_event, newValue: Array<CuppingDescriptor>) => {
        props.onChange(newValue)
      }}
      value={props.selectedDescriptors}
      renderTags={(value: Array<CuppingDescriptor>, getTagProps) =>
        value.map((option: CuppingDescriptor, index: number) => (
          <Chip label={option.name} {...getTagProps({ index })} />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          InputLabelProps={{ shrink: true }}
          label={t('cupping.descriptors')}
          placeholder={t('cupping.adddescriptor')}
        />
      )}
    />
  )
}

export default Descriptors
